// Static maps shared by the proposition shell (header tabs + coach context labels).
// Mirrors TAB_HUBS and contextLabel from the design prototype.

export const HUB_SLUGS = [
  'niche', 'brand', 'roadmap', 'buyer',
  'content', 'portfolio', 'value', 'added',
  'opportunities', 'articles', 'contacts', 'nurture',
];

export const TAB_HUBS = {
  proposition: ['niche', 'brand', 'roadmap', 'content'],
  engaging:    ['buyer', 'content', 'brand', 'opportunities', 'articles', 'contacts', 'nurture'],
  delivery:    ['portfolio', 'value', 'added'],
};

export const TAB_LABELS = [
  { id: 'proposition', num: '01', label: 'Proposition Builder' },
  { id: 'engaging',    num: '02', label: 'Pipeline Builder'    },
  { id: 'delivery',    num: '03', label: 'Delivery Dashboard'  },
];

export const CONTEXT_LABELS = {
  hub:           'Hub · overview',
  niche:         'Niche Definition',
  brand:         'Brand Builder',
  roadmap:       'Roadmap Tool',
  buyer:         'Buyer Journey',
  content:       'Content Plan',
  portfolio:     'Portfolio Management',
  value:         'Value Delivery',
  added:         'Added Value',
  opportunities: 'Active Opportunities',
  articles:      'Articles Tracker',
  contacts:      'Active Contacts',
  nurture:       'Nurture Contacts',
};

export const contextLabel = (slug) => CONTEXT_LABELS[slug] || 'Hub';

// Which hub slugs are visible as canvas nodes on each tab.
// Canvas.jsx uses this to swap its node set when the tab changes.
export const TAB_CANVAS_HUBS = {
  proposition: ['niche', 'brand', 'roadmap', 'buyer', 'content', 'added'],
  engaging:    ['opportunities', 'articles', 'contacts', 'nurture'],
  delivery:    ['portfolio', 'value', 'added'],
};
